// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".finance-payout-form[data-v-26f7c9ee]{max-width:400px;margin:0 auto}.finance-payout-form .actions[data-v-26f7c9ee]{display:flex;justify-content:space-between}.finance-payout__error[data-v-26f7c9ee],.finance-payout__field[data-v-26f7c9ee]{margin-bottom:12px}.finance-payout__info[data-v-26f7c9ee]{margin-top:10px;margin-bottom:24px;color:var(--q4s-accent)}", ""]);
// Exports
module.exports = exports;
